import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import rootReducer from "./store/reducers";
import { Router } from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core";
import THEME from "./utils/theme";
import { MAP_BOUNDS, MAP_HOVER_STOP } from "./store/actions/types";
import "./utils/localization";
import history from "./utils/history";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { version } from "../package.json";
// import UnderConstructionScreen from "./underConstruction/UnderConstructionScreen";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://a7eb0b12ad98413e9e571b715a55f3ba@sentry.routetitan.io/3",
    environment: process.env.REACT_APP_ENVIRONMENT,
    release: version,
    normalizeDepth: 4,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
      })
    ]
    // Disable transaction for now.
    // tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0
  });
}

export const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk),
    window.__REDUX_DEVTOOLS_EXTENSION__ && process.env.NODE_ENV !== "production"
      ? window.__REDUX_DEVTOOLS_EXTENSION__({
          actionsBlacklist: [MAP_HOVER_STOP, MAP_BOUNDS],
          trace: true,
          traceLimit: 25
        })
      : f => f
  )
);

if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) {
        console.error(
          "Cannot remove a child from a different parent",
          child,
          this
        );
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.error(
          "Cannot insert before a reference node from a different parent",
          referenceNode,
          this
        );
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

ReactDOM.render(
  <MuiThemeProvider theme={THEME}>
    <Provider store={store}>
      <Router history={history}>
        <App />
        {/* <UnderConstructionScreen /> */}
      </Router>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
